<template>
	<div class="">
		<vm-header></vm-header>
		<div class="container">
			<div class="topsd">
				<div class="intro1-tit">
					<div class="wl"></div>
					<span>选考科目及对应可报专业情况</span>
				</div>
				<ul>
					<li>
						<span></span>
						<span>人数</span>
					</li>
					<li>
						<span></span>
						<span>比例</span>
					</li>
				</ul>
			</div>
			<wodexuanke></wodexuanke>
			<div class="container_text">
				选考方案及匹配专业情况
			</div>
			<div class="xunhuan">
				<div class="xh" v-for="(item,i) in list">
					<div class="kuang">
						<a href="" class="a1">{{item.tit}}</a>
					</div>
					<div class="kuang">
						<span>{{item.shuzi}}</span>
					</div>
					<div class="kuang">
						<span>{{item.kemu}}</span>
					</div>
					<div class="kuang">
						<span>{{item.bili}}</span>
					</div>
					<div class="kuang">
						<!-- <a href="" class="a2">{{item.sc}}</a>-->
						<span class="a2">{{item.sc}}</span>
					</div>
					<div class="kuang">
						<router-link to="./xuankefangan_zyqkdcb" class="a3"><span>{{item.bili1}}</span></router-link>
					</div>
				</div>
			</div>
			<div class="model">
				<div class="modelb" @click="zhinengxuan">
					<div class="model2">
						<div class="model2-top">
							<img src="../../../static/img/p7.png">
							<span>智能选科</span>
						</div>
						<div class="model2-bottom">
							<span>搜索并选择自己想填报的专业，然后根据选择的专业生成最佳选科方案</span>
						</div>
					</div>
				</div>
				<div class="modelc" @click="gengjucpxuan">
					<div class="model3">
						<div class="model3-top">
							<img src="../../../static/img/p8.png">
							<span>根据测评选科</span>
						</div>
						<div class="model3-bottom">
							<span>搜索并选择自己想填报的专业，然后根据选择的专业生成最佳选科方案</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<item7></item7>
	</div>
</template>

<script>
import vmHeader from '../../components/vmHeader.vue'
import item7 from '../../components/item7.vue'
import wodexuanke from '../tubiao/wodexuanke.vue'
	export default {
		name: "",
		components: {
			wodexuanke,
			vmHeader,
			item7
		},
		data() {
			return {
				
				list: [{
						tit: "选科方案",
						shuzi: "匹配院校",
						kemu: "院校匹配率",
						bili: "匹配专业",
						sc: "专业匹配率",
						bili1: "查看详情"
					}, {
						tit: "物理、化学、生物",
						shuzi: "1650",
						kemu: "90%",
						bili: "1789",
						sc: "80%",
						bili1: "查看专业",
					}, {
						tit: "物理、化学、生物",
						shuzi: "1650",
						kemu: "90%",
						bili: "1789",
						sc: "80%",
						bili1: "查看专业",
					}, {
						tit: "物理、化学、生物",
						shuzi: "1650",
						kemu: "90%",
						bili: "1789",
						sc: "80%",
						bili1: "查看专业",
					}, {
						tit: "物理、化学、生物",
						shuzi: "1650",
						kemu: "90%",
						bili: "1789",
						sc: "80%",
						bili1: "查看专业",
					}, {
						tit: "物理、化学、生物",
						shuzi: "1650",
						kemu: "90%",
						bili: "1789",
						sc: "80%",
						bili1: "查看专业",
					}, {
						tit: "物理、化学、生物",
						shuzi: "1650",
						kemu: "90%",
						bili: "1789",
						sc: "80%",
						bili1: "查看专业",
					}, {
						tit: "物理、化学、生物",
						shuzi: "1650",
						kemu: "90%",
						bili: "1789",
						sc: "80%",
						bili1: "查看专业",
					}, {
						tit: "物理、化学、生物",
						shuzi: "1650",
						kemu: "90%",
						bili: "1789",
						sc: "80%",
						bili1: "查看专业",
					}, {
						tit: "物理、化学、生物",
						shuzi: "1650",
						kemu: "90%",
						bili: "1789",
						sc: "80%",
						bili1: "查看专业",
					},
				
					{
						tit: "物理、化学、生物",
						shuzi: "1650",
						kemu: "90%",
						bili: "1789",
						sc: "80%",
						bili1: "查看专业",
					},
				
					{
						tit: "物理、化学、生物",
						shuzi: "1650",
						kemu: "90%",
						bili: "1789",
						sc: "80%",
						bili1: "查看专业",
					}
				
				]
			}
		},
		methods: {
			// 智能选科
			zhinengxuan(){
				this.$router.push('/zhinengxuanke')
			},
			// 根据测评选科
			gengjucpxuan(){
				// 有俩状态跳转
				this.$router.push('/grzx_cepingjieguo')   //状态1跳转
				// this.$router.push('/zhinengxuanke')  //状态2跳转
			},
		}


	}
</script>

<style scoped>
	.modelb{cursor: pointer;}
	.modelc{cursor: pointer;}
	
	.topsd{width: 100%;align-items: center;display: flex;justify-content: space-between;border-bottom: 1px solid rgba(0, 0, 0, 0.10196078431372549);}
	.topsd ul{display: flex;align-items: center;}
	.topsd ul li {display: flex;align-items: center;margin-left: 25px;}
	.topsd ul li span:nth-of-type(1){width: 36px;height: 20px;border-radius: 5px;display: flex;}
	.topsd ul li span:nth-of-type(2){font-size: 18px;font-family: PingFang SC;font-weight: 500;color: #333333;margin-left: 8px;}
	.topsd ul li:nth-of-type(1) span:nth-of-type(1){background: rgba(41, 167, 225, 1);opacity: 1;}
	.topsd ul li:nth-of-type(2) span:nth-of-type(1){background: rgba(254, 150, 3,1);opacity: 1;}
	.intro1-tit{
		display: flex;
		margin-bottom: 15px;
	}
	.intro1-tit span {
		margin-left: 10px;
		font-size: 20px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #333333;
		line-height: 20px;
		display: flex;
		align-items: center;
	}
	.wl {
		width: 6px;
		height: 22px;
		border-radius: 0px 4px 4px 0px;
		background: #F21323;
	}
	.model {
		display: flex;
		justify-content: center;
	}
	.container{width: 1458px;}
	.a3 {
		color: #F53824;
		border: 1px solid #E63233;
		padding: 5px;
		text-decoration: none;
	}
	.container_text{
		font-size: 20px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #29A7E1;
		line-height: 50px;
	}
	.model3-bottom {
		margin: 10px;
		text-align: center;
	}
	
	.zhong {
		margin: 0 auto;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.model3-bottom span {
		display: block;
		font-size: 14px;
		font-weight: 500;
		color: #FFFFFF;
		opacity: 1;
	}
	
	.model3-top span {
		text-align: center;
		line-height: 70px;
		font-size: 24px;
		font-weight: 500;
		color: #FFFFFF;
		opacity: 1;
	}
	
	.model3-top {
		justify-content: center;
		display: flex;
		color: white;
	
	}
	
	.model3 {
		padding: 15px 40px;
		width: 390px;
		height: 172px;
		background: url(../../../static/img/p5.png);
		background-size: 100% 100%;
	}
	
	
	.model2-bottom {
		margin: 10px;
		text-align: center;
	}
	
	.zhong {
		margin: 0 auto;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.model2-bottom span {
		display: block;
		font-size: 14px;
		font-weight: 500;
		color: #FFFFFF;
		opacity: 1;
	}
	
	.model2-top span {
		text-align: center;
		line-height: 70px;
		font-size: 24px;
		font-weight: 500;
		color: #FFFFFF;
		opacity: 1;
	}
	
	.model2-top {
		justify-content: center;
		display: flex;
		color: white;
	
	}
	
	.model2 {
		padding: 15px 40px;
		box-sizing: border-box;
		width: 390px;
		height: 172px;
		background: url(../../../static/img/p4.png);
		background-size: 100% 100%;
	}
	
	.xunhuan .xh:nth-of-type(1) .kuang:nth-of-type(1) {
		border: none;
	}
	
	.xunhuan .xh:nth-of-type(1) .kuang:nth-of-type(2) {
		border: none;
	}
	
	.xunhuan .xh:nth-of-type(1) .kuang:nth-of-type(3) {
		border: none;
	}
	
	.xunhuan .xh:nth-of-type(1) .kuang:nth-of-type(4) {
		border: none;
	}
	
	.xunhuan .xh:nth-of-type(1) .kuang:nth-of-type(5) {
		border: none;
	}
	
	.xunhuan .xh:nth-of-type(1) .kuang:nth-of-type(6) {
		border: none;
	}
	
	.xunhuan .xh:nth-of-type(1) a:nth-of-type(1) {
		color: white;
		border: none;
	}
	
	.xunhuan .xh:nth-of-type(1) {
		border: none !important;
		color: white !important;
		background: rgb(246, 100, 100);
		opacity: 1;
	}
	.xunhuan .xh:nth-of-type(1) span{
		color: #FFFFFF;
		font-size: 18px;
		font-family: PingFang SC;
		font-weight: 500;
	}
	.xunhuan .xh{margin-bottom: 10px;border-radius: 5px;}
	
	.xunhuan .xh .kuang:nth-of-type(1){
		border-radius: 5px 0 0 5px;
	}
	.xunhuan .xh .kuang:nth-of-type(6){
		border-radius:0 5px 5px 0;
	}
	
	.xunhuan {
		display: block;
	}
	
	.xh {
	
		height: 50px;
		display: flex
	}
	
	.kuang {
		border: 1px solid #EBE9E9;
		width: 20%;
	}
	
	.xunhuan .a2 {
		text-decoration: none;
		font-size: 18px;
		font-weight: 500;
		line-height: 20px;
		/* color: #FE9603; */
		opacity: 1;
	}
	
	.xunhuan .a1 {
		text-decoration: none;
		color: #29A7E1;
		font-size: 18px;
		font-weight: 500;
		line-height: 20px;
		color: #29A7E1;
		opacity: 1;
	}
	
	.kuang {
		align-items: center;
		justify-content: center;
		display: flex;
	}
	
	.xunhuan {
		color: #666666;
		text-align: center;
		justify-content: space-evenly;
	}
	
	@media (max-width:750px) {
		.xunhuan .xh:nth-of-type(1) .a2:nth-of-type(1) {
			 font-size: 12px;
		}
		
		.xunhuan {
			display: block;
		}
	
		.xh {
			display: flex;
		}
	
		.xunhuan .a1 {
			font-size: 13px;
		}
	
		.model {
			display: block
		}
		.model2{
			width: auto;
		}
		.model3{
			width: auto;
		}
		.a3{
			font-size: 12px;
			padding: 0;
		}
		.xunhuan .xh:nth-of-type(1){
			font-size: 12px;
		}
		
		/* 改 */
		.topsd{align-items: flex-start;flex-direction: column;}
		.xunhuan{overflow-y: hidden;overflow-x: auto;}
		.xunhuan .xh{width: 850px;}
	}
</style>



// WEBPACK FOOTER //
// src/views/mine/g_xuankeqingkuangcaxunye.vue